import {
  Vue, Options
} from 'vue-class-component'
// import swal from 'sweetalert'
import Swal from 'sweetalert2'
import Header from '@/components/Header.vue'
import { masterDataFactory } from '@/http/master-data'
import { cheatDataFactory } from '@/http/cheat-data'
import LocalStorage from '@/utils/localstorage'

@Options({
  components: {
    Header
  },
  data () {
    return {
      configs: [],
      counter: 0,
      cheatMode: false,
      cheat1: {
        invoice_no: '',
        status: '',
        payment_date: '',
        bulk: '',
        bulkMode: false
      },
      cheat2: {
        order_ids: ''
      },
      cheat3: {
        invoice_nos: ''
      },
      cheat4: {
        order_ids: ''
      },
      cheat5: {
        invoice_no: '',
        bill_id: '',
        bulk: '',
        bulkMode: false
      },
      cheat6: {
        invoice_no: '',
        nominal: '',
        bulk: '',
        bulkMode: false
      }
    }
  },
  methods: {
    welcome () {
      Swal.fire({
        title: '<br><span style="text-shadow: 2px 2px black;">Baca Petunjuk Dengan Teliti!!!</span><br><br>',
        width: 480,
        padding: '3em',
        color: '#fff',
        background: '#fff url(https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExbmxybm10YnJ0ODkxanNrN2hzbWxqZ3h3OW00NW1pcTJnZXhyMTMwMCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/DExlA3pBZEDx0Vk41Z/giphy.webp)',
        backdrop: `
                  rgba(0,0,123,0.4)
                  url("https://media.tenor.com/nN4erWoujAgAAAAj/toothless-cat-cat.gif")
                  center top
                `
      })
    },
    checkCheatMode () {
      const cheatToken = LocalStorage.getOne('cheatToken') || ''
      if (cheatToken != '') {
        // validate cheat token
        Promise.resolve(cheatDataFactory.validateCheatToken({ token: cheatToken })).then(
          (res) => {
            this.cheatMode = res.data

            if (!this.cheatMode) {
              this.redirectConfigs()
            } else {
              this.welcome()
            }
          }
        )
      } else {
        if (!this.cheatMode) {
          this.redirectConfigs()
        } else {
          this.welcome()
        }
      }
    },
    redirectConfigs () {
      // remove cheat token
      LocalStorage.remove('cheatToken')

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Cheat mode is not activated, redirecting to configurations in 3 seconds'
      })

      // redirect to /configs in 3 seconds
      setTimeout(() => {
        // this.$router.push('/configs')
        location.href = '/configs'
      }, 3000)
    },
    cheat1Submit () {
      Swal.fire({
        title: 'Ubah status Pembayaran?',
        text: 'Apakah anda yakin ingin mengubah status pembayaran?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // post to api
          Promise.resolve(cheatDataFactory.cheat1(this.cheat1)).then(
            (res) => {
              if (res.data) {
                if (this.cheat1.bulkMode == false) {
                  if (res.data.result.success == true) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: 'Invoice No: ' + this.cheat1.invoice_no + ' updated'
                    })
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Failed to update'
                    })
                  }
                } else {
                  const success = []
                  const failed = []
                  res.data.result.failed.forEach((element: any) => {
                    failed.push(element.invoice_no)
                  })
                  res.data.result.success.forEach((element: any) => {
                    success.push(element.invoice_no)
                  })

                  let text = ''
                  if (success.length > 0) {
                    text += 'Success: ' + success.join(', ') + '\n'
                  }
                  if (failed.length > 0) {
                    text += 'Failed: ' + failed.join(', ') + '\n'
                  }

                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: text
                  })
                }
                this.cheat1.invoice_no = ''
                this.cheat1.status = ''
                this.cheat1.payment_date = ''
                this.cheat1.bulk = ''
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to update'
                })
              }
            }
          )
        }
      })
    },
    cheat2Submit () {
      Swal.fire({
        title: 'Resend Callback Mrkrabs?',
        text: 'Apakah anda yakin ingin mengirim ulang callback Mrkrabs?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // post to api
          Promise.resolve(cheatDataFactory.cheat2(this.cheat2)).then(
            (res) => {
              if (res.data) {
                const success = []
                const failed = []
                res.data.result.failed.forEach((element: any) => {
                  failed.push(element)
                })
                res.data.result.success.forEach((element: any) => {
                  success.push(element)
                })

                let text = ''
                if (success.length > 0) {
                  text += 'Success: ' + success.join(', ') + '\n'
                }
                if (failed.length > 0) {
                  text += 'Failed: ' + failed.join(', ') + '\n'
                }

                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: text
                })
                this.cheat2.order_ids = ''
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to update'
                })
              }
            }
          )
        }
      })
    },
    cheat3Submit () {
      Swal.fire({
        title: 'Hapus Invoice Terbayar?',
        text: 'Apakah anda yakin ingin menghapus invoice yang sudah terbayar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // post to api
          Promise.resolve(cheatDataFactory.cheat3(this.cheat3)).then(
            (res) => {
              if (res.data) {
                const success = []
                const failed = []
                res.data.result.failed.forEach((element: any) => {
                  failed.push(element)
                })
                res.data.result.success.forEach((element: any) => {
                  success.push(element)
                })

                let text = ''
                if (success.length > 0) {
                  text += 'Success: ' + success.join(', ') + '\n'
                }
                if (failed.length > 0) {
                  text += 'Failed: ' + failed.join(', ') + '\n'
                }

                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: text
                })
                this.cheat3.invoice_nos = ''
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to update'
                })
              }
            }
          )
        }
      })
    },
    cheat4Submit () {
      Swal.fire({
        title: 'Reactivate Expired Order?',
        text: 'Apakah anda yakin ingin mengaktifkan kembali order yang sudah expired?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // post to api
          Promise.resolve(cheatDataFactory.cheat4(this.cheat4)).then(
            (res) => {
              if (res.data) {
                const success = []
                const failed = []
                res.data.result.failed.forEach((element: any) => {
                  failed.push(element)
                })
                res.data.result.success.forEach((element: any) => {
                  success.push(element)
                })

                let text = ''
                if (success.length > 0) {
                  text += 'Success: ' + success.join(', ') + '\n'
                }
                if (failed.length > 0) {
                  text += 'Failed: ' + failed.join(', ') + '\n'
                }

                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: text
                })
                this.cheat4.order_ids = ''
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to update'
                })
              }
            }
          )
        }
      })
    },
    cheat5Submit () {
      Swal.fire({
        title: 'Pindah Pembayaran?',
        text: 'Apakah anda yakin ingin memindahkan pembayaran?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // post to api
          Promise.resolve(cheatDataFactory.cheat5(this.cheat5)).then(
            (res) => {
              if (res.data) {
                if (this.cheat5.bulkMode == false) {
                  if (res.data.result.success == true) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: 'Invoice No: ' + this.cheat5.invoice_no + ' switched to Bill ID: ' + this.cheat5.bill_id
                    })
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Failed to update'
                    })
                  }
                } else {
                  const success = []
                  const failed = []
                  res.data.result.failed.forEach((element: any) => {
                    failed.push(element.invoice_no)
                  })
                  res.data.result.success.forEach((element: any) => {
                    success.push(element.invoice_no)
                  })

                  let text = ''
                  if (success.length > 0) {
                    text += 'Success: ' + success.join(', ') + '\n'
                  }
                  if (failed.length > 0) {
                    text += 'Failed: ' + failed.join(', ') + '\n'
                  }

                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: text
                  })
                }
                this.cheat5.invoice_no = ''
                this.cheat5.bill_id = ''
                this.cheat5.bulk = ''
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to update'
                })
              }
            }
          )
        }
      })
    },
    cheat6Submit () {
      Swal.fire({
        title: 'Ubah Nominal Pembayaran?',
        text: 'Apakah anda yakin ingin mengubah nominal pembayaran?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // post to api
          Promise.resolve(cheatDataFactory.cheat6(this.cheat6)).then(
            (res) => {
              if (res.data) {
                if (this.cheat6.bulkMode == false) {
                  if (res.data.result.success == true) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: 'Invoice No: ' + this.cheat6.invoice_no + ' updated'
                    })
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Failed to update'
                    })
                  }
                } else {
                  const success = []
                  const failed = []
                  res.data.result.failed.forEach((element: any) => {
                    failed.push(element.invoice_no)
                  })
                  res.data.result.success.forEach((element: any) => {
                    success.push(element.invoice_no)
                  })

                  let text = ''
                  if (success.length > 0) {
                    text += 'Success: ' + success.join(', ') + '\n'
                  }
                  if (failed.length > 0) {
                    text += 'Failed: ' + failed.join(', ') + '\n'
                  }

                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: text
                  })
                }
                this.cheat6.invoice_no = ''
                this.cheat6.nominal = ''
                this.cheat6.bulk = ''
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Failed to update'
                })
              }
            }
          )
        }
      })
    }
  },
  watch: {
    configs: {
      handler: function (val) {
        // post to api
        if (this.counter > 0) {
          Promise.resolve(masterDataFactory.setConfigs({ configs: val })).then(
            (res) => {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Configs updated'
              })
            }
          )
        }
        this.counter++
      },
      deep: true
    }
  },
  async mounted () {
    Promise.resolve(masterDataFactory.getConfigs()).then(
      (res) => {
        this.configs = res.data.configs
      }
    )

    this.checkCheatMode()
  }
})

export default class VAImport extends Vue { }
